import type { AxiosResponse } from 'axios';

function generateName() {
  const today = new Date();
  const date =
    today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
  const time =
    today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
  return `report-${date} ${time}.csv`;
}

function downloadUrl({ url, filename }: { url: string; filename?: string }) {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename ?? generateName());
  link.setAttribute('target', '_blank');
  link.click();
  link.remove();
}

function exportable(response: AxiosResponse<BlobPart>, filename?: string) {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  downloadUrl({ url, filename });
  URL.revokeObjectURL(url);
}
export { downloadUrl, exportable };
